import { forwardRef } from 'react';
import { BaseToggleButton } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToggleButton = /*#__PURE__*/forwardRef(function ToggleButton({
  icon,
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(BaseToggleButton, {
    ...props,
    ref: ref,
    icon: props.text ? undefined : icon
  });
});
export const getToggleButtonDesignTokens = (dt, opts) => {
  const {
    disabled,
    pressed,
    isActive
  } = opts;
  const commonTokens = {
    '--button-focus-outline': (pressed || isActive) && dt.themeVariant === 'high-contrast' ? 'var(--focus-dark-bg)' : 'var(--focus-light-bg)',
    '--button-active-filter': 'none',
    '--button-active-fg': dt.tokens['color-action-text-standard-selected'],
    '--button-active-bg': dt.tokens['color-action-background-standard-selected'],
    '--button-active-bd': dt.tokens['color-action-border-standard-selected']
  };
  if (pressed) {
    if (disabled) {
      // Pressed disabled
      return {
        ...commonTokens,
        '--button-fg': dt.tokens['color-action-text-standard-disabled'],
        '--button-bg': dt.tokens['color-action-background-standard-disabled'],
        '--button-bd': dt.tokens['color-action-border-standard-disabled'],
        '--button-hover-fg': 'var(--button-fg)',
        '--button-hover-bg': 'var(--button-bg)',
        '--button-hover-bd': 'var(--button-bd)',
        '--button-active-fg': 'var(--button-fg)',
        '--button-active-bg': 'var(--button-bg)',
        '--button-active-bd': 'var(--button-bd)'
      };
    } else {
      // Pressed enabled
      return {
        ...commonTokens,
        '--button-fg': dt.tokens['color-action-text-standard-selected'],
        '--button-bg': dt.tokens['color-action-background-standard-selected'],
        '--button-bd': dt.tokens['color-action-border-standard-selected'],
        '--button-hover-fg': 'var(--button-fg)',
        '--button-hover-bg': 'var(--button-bg)',
        '--button-hover-bd': 'var(--button-bd)'
      };
    }
  }
  return commonTokens;
};
//# sourceMappingURL=ToggleButton.js.map